const nonNumeric = new RegExp('[^0-9]','g');
export default nonNumeric;






// WEBPACK FOOTER //
// ./src/common/reg/nonNumeric.js